import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN' // lang i18n
import VCharts from 'v-charts'

import '@/styles/index.scss' // global css

import App from './App'
import router from './router'
import store from './store'

import '@/icons' // icon
import '@/permission'
import getters from "./store/getters"; // permission control

Vue.use(ElementUI, { locale })
Vue.use(VCharts)

Vue.config.productionTip = false


// ======================================
// 新增：按钮权限自定义指令（核心代码）
// ======================================    v-btn-permission="'pms:product:add'"
// 注册全局指令：v-btn-permission（也可以用v-permission，避免和其他指令冲突建议用btn-permission）
Vue.directive('btn-permission', {
  // 指令绑定到元素时触发
  bind(el, binding) {
    handleBtnPermission(el, binding, store)
  },
  // 元素更新时触发（比如权限数据动态变化）
  update(el, binding) {
    handleBtnPermission(el, binding, store)
  }
})

// 抽离按钮权限判断的核心逻辑（复用）
function handleBtnPermission(el, binding, store) {

  // 新增：获取用户名（需从Vuex/localStorage中获取）
  const username = store.state.user.username || localStorage.getItem('username');
  // admin用户直接拥有所有权限，无需判断
  if (username === 'admin') {
    return;
  }

  // 1. 从Vuex的permission模块中获取按钮权限列表
  // 注意：这里的路径要和你permission.js中的state字段一致
  // const buttonPermissions = store.state.permission.buttonPermissions || []

  const buttonPermissions = store.getters.btnRole
  console.log('buttonPermissions: ',buttonPermissions)


  // 2. 获取指令传入的权限标识（可以是字符串或数组）
  const requiredPerms = binding.value

  // 没有传入权限标识，默认显示元素（可根据需求调整）
  if (!requiredPerms) {
    return
  }

  // 3. 判断用户是否拥有权限
  let hasPermission = false
  // 处理单个权限（字符串）
  if (typeof requiredPerms === 'string') {
    hasPermission = buttonPermissions.includes(requiredPerms)
  }
  // 处理多个权限（数组）
  else if (Array.isArray(requiredPerms)) {
    // 支持两种规则：
    // - 默认为“或”规则：拥有任意一个权限即可（some）
    // - .and修饰符：必须拥有所有权限（every）
    hasPermission = binding.modifiers.and
      ? requiredPerms.every(perm => buttonPermissions.includes(perm))
      : requiredPerms.some(perm => buttonPermissions.includes(perm))
  }

  // 4. 没有权限则移除元素（用setTimeout兼容异步渲染场景，比如表格内的按钮）
  if (!hasPermission) {
    setTimeout(() => {
      el.parentNode && el.parentNode.removeChild(el)
    }, 0)
  }
}
// ======================================
// 新增代码结束
// ======================================


new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js